import Component from '@bythepixel/component-loader';
import { CountUp } from 'countup.js';

export default class StatsCount extends Component {
  static selector = '[data-comp-stats-count]';
  constructor(containerEl) {
    super(containerEl);
    const countTo = this.$container.dataset.compStatsCount;
    const decimalIndex = countTo.indexOf('.');
    const hasDecimal = decimalIndex !== -1;
    const decimalPlaces = hasDecimal ? countTo.length - decimalIndex - 1 : 0;

    const numAni = new CountUp(this.$container, parseFloat(countTo), {
      decimalPlaces,
      duration: 1,
      useEasing: false,
    });

    const observer = new IntersectionObserver(elToBeObserved => {
      if (elToBeObserved[0].intersectionRatio) {
        numAni.start();
      }
    });

    observer.observe(this.$container);
  }
}
